import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { viewModelToInput } from "@/components/features/snack/snack/_shared/model/use-create-snack-form-base-model/converter/view-model-to-input";
import type { DesignSnackFormBaseModel } from "@/components/features/snack/snack/_shared/model/use-create-snack-form-base-model/type";

import { SnackUpdate_SnackPage_Mutation } from "./mutation";

export const useSnackUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(SnackUpdate_SnackPage_Mutation);

	const onUpdate = useCallback(
		async ({ viewModel }: { viewModel: DesignSnackFormBaseModel["ViewModel"] }) => {
			const input = viewModelToInput({ viewModel });

			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		onUpdate,
	};
};
